import { Router } from '@angular/router';
import { Component } from '@angular/core';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { Device } from '../../../common/interfaces/item.interface';

import { ThermostatProgrammingContext } from '../quickstart-thermostats.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';


@Component({
  templateUrl: './select-thermostat.component.html',
  styleUrls: ['../../../common/assets/styles/common.less']
})
export class QSThermostatSelectThermostatComponent extends BaseRoutingComponent {

  private _thermostats: Observable<Device[]>;

  constructor(
    protected router: Router,
    protected store: Store<{
      thermostatProgramming: ThermostatProgrammingContext
    }>
  ) {
    super();
    this._thermostats = this.store.select(s => s.thermostatProgramming.thermostats);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-thermostats/select-thermostat/select-thermostat.component.ts